export default __webpack_public_path__ + "static/media/Warmaster Dreadfists.9f712a4e.jpg";